import Link from 'next/link';
import styled from 'styled-components';

import {
  getStudyBookMenuItems,
  isStudyRelatedCategory,
  STUDY_BOOK_LABEL,
  STUDY_LABEL,
} from 'src/app.core/nurseEdu/component/Header';

import { CategoryDto } from 'src/app.core/nurseEdu/hook/useHeaderCategories';
import {
  NURSEEDU_BASE_URL,
  NURSEEDU_CBT_BASE_URL,
  NURSEEDU_STUDY_BASE_URL,
  NURSE_LINK_BASE_URL,
  NURSEEDU_COMMUNITY_BASE_URL,
} from 'src/app.core/nurseEdu/constant/nurseEduConfig';

interface HeaderNavModalProps {
  isOpen: boolean;
  categories: CategoryDto[] | undefined;
  onClose?: () => void;
}

const HeaderNavModal = ({ isOpen, categories, onClose }: HeaderNavModalProps) => {
  const studyBookMenuItems = getStudyBookMenuItems(categories);

  if (!isOpen) return null;

  return (
    <>
      <StyledNavModalContainer>
        {categories?.map(({ label, categoryId }) => {
          if (isStudyRelatedCategory(label)) return null; // 학습 메뉴는 아래 별도 처리

          const href = `${NURSEEDU_BASE_URL}/list/${categoryId}`;

          return (
            <StyledNavBtnLink key={categoryId} href={href} onClick={onClose}>
              {label}
            </StyledNavBtnLink>
          );
        })}

        {/* 스마트학습구매 — 클릭 시 첫 번째 하위 교재로 이동 (hover 불가하므로 단일 진입) */}
        {studyBookMenuItems[0] && (
          <StyledNavBtnLink
            href={`${NURSEEDU_BASE_URL}/list/${studyBookMenuItems[0].categoryId}`}
            onClick={onClose}
          >
            {STUDY_BOOK_LABEL}
          </StyledNavBtnLink>
        )}

        {/* 스마트학습하기 — 외부 스터디 모듈 */}
        <StyledNavBtnLink href={NURSEEDU_STUDY_BASE_URL} onClick={onClose}>
          {STUDY_LABEL}
        </StyledNavBtnLink>

        <StyledNavBtnLink href={NURSEEDU_CBT_BASE_URL} $active={true}>
          CBT
        </StyledNavBtnLink>
        <StyledNavBtnLink href={NURSEEDU_COMMUNITY_BASE_URL} prefetch={false}>
          커뮤니티
        </StyledNavBtnLink>
        <StyledNavBtnLink href={NURSE_LINK_BASE_URL}>채용공고</StyledNavBtnLink>
      </StyledNavModalContainer>
    </>
  );
};

export default HeaderNavModal;

const StyledNavModalContainer = styled.div`
  position: absolute;
  width: 100%;
  padding: 12px;
  background: #fff;
  border-bottom: 1px solid #d9dce1;
  border-top: 1px solid #d9dce1;
  display: none;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;

  z-index: 12;
  top: 106px;

  @media (max-width: 767px) {
    display: flex;
  }
`;

const StyledNavBtnLink = styled(Link)<{ $active?: boolean }>`
  height: 40px;
  padding: 10px 14px;
  background: rgba(245, 245, 245, 0.3);
  border-radius: 59px;
  outline: 1px solid ${({ $active }) => ($active ? '#38459F' : '#D9DCE1')};
  outline-offset: -1px;
  display: flex;
  align-items: center;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active }) => ($active ? '#38459F' : '#222')};
  line-height: 22.4px;
  word-break: keep-all;
  text-decoration: none;
  transition: outline 0.15s, color 0.15s, font-weight 0.15s;
`;
